import { BAILocale } from '.';
import pt_PT from 'antd/es/locale/pt_PT';

const localeValue: BAILocale = {
  lang: 'pt',
  antdLocale: pt_PT,
};

export default localeValue;
